/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Publication lifecycle mode.
 */
export enum PropertyPortalPublicationRecordMode {
    MANAGED_PUBLISH = 'managed_publish',
    MANAGED_SYNC = 'managed_sync',
    OBSERVED_EXTERNAL = 'observed_external',
}
